var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteAddManually(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6552 0H1.34483C0.6021 0 0 0.575634 0 1.28571V7.71429C0 8.42437 0.6021 9 1.34483 9H37.6552C38.3979 9 39 8.42437 39 7.71429V1.28571C39 0.575634 38.3979 0 37.6552 0Z",
    fill: "#C0D8D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 2H3.75C3.33579 2 3 2.44772 3 3C3 3.55228 3.33579 4 3.75 4H10.25C10.6642 4 11 3.55228 11 3C11 2.44772 10.6642 2 10.25 2Z",
    fill: "#619D94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 5H3.78C3.34922 5 3 5.44772 3 6C3 6.55228 3.34922 7 3.78 7H15.22C15.6508 7 16 6.55228 16 6C16 5.44772 15.6508 5 15.22 5Z",
    fill: "#4E7E76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6552 11H1.34483C0.6021 11 0 11.5756 0 12.2857V18.7143C0 19.4244 0.6021 20 1.34483 20H37.6552C38.3979 20 39 19.4244 39 18.7143V12.2857C39 11.5756 38.3979 11 37.6552 11Z",
    fill: "#C0D8D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13H3.75C3.33579 13 3 13.4477 3 14C3 14.5523 3.33579 15 3.75 15H10.25C10.6642 15 11 14.5523 11 14C11 13.4477 10.6642 13 10.25 13Z",
    fill: "#619D94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 16H3.78C3.34922 16 3 16.4477 3 17C3 17.5523 3.34922 18 3.78 18H15.22C15.6508 18 16 17.5523 16 17C16 16.4477 15.6508 16 15.22 16Z",
    fill: "#4E7E76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6552 22H1.34483C0.6021 22 0 22.5756 0 23.2857V29.7143C0 30.4244 0.6021 31 1.34483 31H37.6552C38.3979 31 39 30.4244 39 29.7143V23.2857C39 22.5756 38.3979 22 37.6552 22Z",
    fill: "#C0D8D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 24H3.75C3.33579 24 3 24.4477 3 25C3 25.5523 3.33579 26 3.75 26H10.25C10.6642 26 11 25.5523 11 25C11 24.4477 10.6642 24 10.25 24Z",
    fill: "#619D94"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 27H3.78C3.34922 27 3 27.4477 3 28C3 28.5523 3.34922 29 3.78 29H15.22C15.6508 29 16 28.5523 16 28C16 27.4477 15.6508 27 15.22 27Z",
    fill: "#4E7E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteAddManually);
export default __webpack_public_path__ + "static/media/inviteAddManually.5aa41ed4a2043d6bf64786ed814f2000.svg";
export { ForwardRef as ReactComponent };